import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: "bfs"
}, "BFS", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", { value: "dijkstra" }, "Dijkstra", -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridComponent = _resolveComponent("GridComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.algo) = $event)),
      required: "",
      name: "algorithm"
    }, _hoisted_3, 512), [
      [_vModelSelect, _ctx.algo]
    ]),
    _createVNode(_component_GridComponent, { algorithm: _ctx.algo }, null, 8, ["algorithm"])
  ], 64))
}